// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
// Entry imports
const configureStore = require('client-v2/logged-out-landing/state/store')
const rootFactory = require('client-v2/logged-out-landing/components/root').factory

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  commonClient.configureSession(store, {
    pageName: 'LOHP'
  })

  businessEvents.trackSegment('pageview')

  const initialState = store.getState()
  const { pathname } = initialState.router.location
  if (pathname === '/login') {
    // Allow login modal pop-up if specified by pathname
    store.dispatch(authModalActions.showLogin())
  }
})
